<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>{{ directory }} Images</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <vue-dropzone
          ref="dropzone"
          id="dropzone"
          :options="dropzoneOptions"
          @vdropzone-success-multiple="processMultipleFiles" />
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />
      <v-text-field v-model="search"
                    label="Search"
                    append-icon="search" />
    </v-row>
    <v-row v-if="loading">
      <v-col cols="12" sm="6" md="4" lg="3" v-for="n in 4" :key="`loading-sheet-${n}`">
        <v-sheet class="px-3 pt-3 pb-3"
                 color="grey lighten-4">
          <v-skeleton-loader
            class="mx-auto"
            max-width="300"
            type="card" />
        </v-sheet>
      </v-col>
    </v-row>
    <v-row v-else-if="visibleImages.length">
      <v-col cols="12"
             sm="6"
             md="4"
             lg="3"
             v-for="image in visibleImages"
             :key="image.Id">
        <v-card>
          <v-card-title>
            <p class="d-inline-block text-truncate">
              {{ image.Title }}
            </p>
          </v-card-title>

          <v-card-subtitle>
            {{ image.Type }}
          </v-card-subtitle>

          <v-img :src="getImage(image.Id)" height="194" />

          <v-card-text>
            <p class="my-0">Created on {{ friendlyDate(image.CreatedOn) }}</p>
          </v-card-text>

          <v-card-actions v-if="$store.getters.can('Editor')">
            <v-spacer />
            <v-tooltip top :activator="`#deleteBtn-${image.Id}`">
              Delete
            </v-tooltip>
            <v-btn icon color="accent"
                   :id="`deleteBtn-${image.Id}`"
                   @click="$refs.confirm.open(image)">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" v-if="pagedImages.length > 1">
        <v-pagination v-model="page"
                      :total-visible="12"
                      :length="pagedImages.length" />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <p>No images found</p>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <ConfirmDialog ref="confirm"
                     title="WARNING"
                     width="350"
                     @continue="deleteFile($event)">
        This action will permanently delete this file,
        and remove all references from Providers and Locations that may use it.<br><br>
        <strong>Are you sure you would like to proceed?</strong>
      </ConfirmDialog>
    </v-row>
  </v-container>
</template>

<style lang="scss">
  .v-app-bar.v-app-bar--fixed {
    z-index: 1005;
  }
  .v-navigation-drawer--temporary {
    z-index: 1007;
  }
</style>

<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vueDropzone from 'vue2-dropzone';
import { friendlyDate } from '@/components/Mixins/FriendlyFields';
import { arrayChunk, arraySearch } from '@/util/Helpers';

export default {
  name: 'MediaDirectory',
  components: {
    vueDropzone,
  },
  props: {
    directory: String,
  },
  data() {
    return {
      loading: true,
      images: [],
      page: 1,
      perPage: 24,
      search: '',
      dropzoneOptions: {
        url: `${this.$http.defaults.baseURL}/Media/${this.directory}`,
        headers: {
          Authorization: `Bearer ${this.$store.getters.user.access_token}`,
        },
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        uploadMultiple: true,
        acceptedFiles: 'image/*',
      },
    };
  },
  computed: {
    visibleImages() {
      return this.pagedImages[this.page - 1];
    },
    pagedImages() {
      const filtered = arraySearch(this.images, this.search, 'Title');
      return arrayChunk(filtered, this.perPage);
    },
  },
  methods: {
    friendlyDate,
    getImage(id) {
      return `${process.env.VUE_APP_API}/Media/${id}`;
    },
    async deleteFile(image) {
      const originalIndex = this.images.indexOf(image);
      try {
        await this.$store.dispatch('delete', `Media/${image.Id}`);
        this.$delete(this.images, originalIndex);
      } catch (e) {
        // Do nothing
      }
    },
    processMultipleFiles(files, response) {
      const newImages = response.filter((m) => m.Replaced === false);
      if (newImages.length) {
        this.images.push(...newImages);
      }
    },
  },
  async created() {
    const response = await this.$store.dispatch('get', `Media/${this.directory}`);
    this.images = response.data;
    this.loading = false;
  },
};
</script>
